<template>
  <section>
    <div class="inner">
      <h1>
        <router-link to="/"><img src="/images/logo_escort.svg" class="logo"></router-link>
      </h1>
      <p>いつも人に寄り添い、時代とともに進化し続ける<br>バスサルーン エスコート。</p>
      <p><strong>もっと安全に。 もっと快適に。そして環境に優しく。</strong></p>
      <img src="/images/logo_gd.svg" class="goodDesign">
      <div class="scroll is-tb">
        <p>Scroll</p>
        <img src="/images/arrow_bottom.png" alt="">
      </div>
    </div>
    
    <div class="movieWrap">
      <div class="movie" @click="showModal">
        <p class="movie-img"></p>
      </div>
      <app-modal v-if="isShow" @close="closeModal" :srcUrl="url"></app-modal>
      <div class="movie--02" @click="showModal02">
        <p class="movie-img"></p>
      </div>
      <app-modal v-if="isShow02" @close="closeModal02" :srcUrl="url02"></app-modal>
    </div>


    <div class="bnr">
      <div><a href="https://www.bathsaloon.jp/color_simulation/" target="_blank"><img src="/images/bnr-simulator.png" alt="color simulation カラーシミュレーション"></a></div>
      <div><a href="https://plan.sekisui-hometechno.co.jp/plan/index.html" target="_blank"><img src="/images/bnr-raku.png" alt="らくりえーたー"></a></div>
      <div><a href="https://sekisuihometechno.meclib.jp/SHT0100/book/" target="_blank"><img src="/images/bnr-catalog.png" alt="バスサルーン エスコート 浴室の新しいカタチ"></a></div>
      <div><a href="https://basic.archi-twin.com/showcase/model3d_public/369?token=7da88c65-ce7c-480a-a778-ef084d04cff2" target="_blank"><img src="/images/bnr-virtualshowroom.png" alt="NEW OPEN VIRTUAL SHOWROOM バーチャルショールーム"></a></div>
    </div>
  </section>
</template>

<script>
import AppModal from '@/components/AppModal.vue'

export default {
  name: 'SlideHero',
  components: {
    AppModal
  },
  data:function(){
    return {
      isShow: false,
      isShow02: false,
      url: "https://www.youtube.com/embed/gQFcKg0szGA?rel=0",
      url02: "https://player.vimeo.com/video/617523762?h=2c5938f0d0"
    }
  },
  methods: {
    showModal: function(){
      this.isShow = true;
    },
    closeModal: function(){
      this.isShow = false;
    },
    showModal02: function(){
      this.isShow02 = true;
    },
    closeModal02: function(){
      this.isShow02 = false;
    },
  },
}
</script>

<style scoped lang="scss">
section {
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url("/images/hero.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  @include mq(tb) {
    height: auto;
    background-image: url("/images/hero_sp.jpg");
    background-position: top center;
  }

  .inner {
    position: absolute;
    top: 50%;
    left: 7.5vw;
    transform: translateY(-50%);

    @include mq(tb) {
      padding: 39.1vh 0 32px;
      position: static;
      transform: none;
      text-align: center;
    }
  }
}

.bnr {
  position: absolute;
  top: 3vw;
  right: 3vw;

  a {
    display: block;
  }

  img {
    width: 180px;

    @include mq(tb) {
      width: 140px;
    }
  }

  div + div {
    margin-top: 8px;

    @include mq(tb) {
      margin-top: 4px;
    }
  }
}

h1 {
  margin-bottom: 4.2vh;

  @include mq(tb) {
    margin: 0 0 24px;
  }

  .logo {
    width: 270px;
    height: 110px;

    @include mq(tb) {
      width: 233px;
      height: auto;
    }
  }
}

p {
  font-size: 14px;
  line-height: 2;

  @include mq(tb) {
    font-size: 13px;
  }

  strong {
    font-size: 16px;

    @include mq(tb) {
      font-size: 13px;
    }
  }

  + p {
    margin-top: 1vh;

    @include mq(tb) {
      margin-top: 12px;
    }
  }
}

.goodDesign {
  width: 181px;
  height: 38px;
  margin-top: 2.5vh;
}

.scroll {
  margin-top: 32px;

  p {
    font-size: 14px;
    font-family: $bellFont;
  }

  img {
    width: 41px;
  }
}
.movieWrap{
  display: block;
  position: absolute;
  width: 10%;
  max-width: 200px;
  min-width: 180px;
  top: 1vw;
  left: 7.5vw;
  @include mq(tb) {
    width: 30%;
    min-width: 150px;
    //max-width: 200px;
    top: 3vw;
    left: 3vw;
  }
}
.movie{
  cursor: pointer;
  .movie-img{
    height: 0;
    line-height: 0;
    padding-top: 51.8%;
    background: url(/images/movie_20200310.jpg) 0 0 no-repeat;
    background-size: 100% auto;
  }

  &--02{
    @extend .movie;
    margin-top: 8px;
    .movie-img{
      height: 0;
      line-height: 0;
      padding-top: 51.8%;
      background: url(/images/movie_autoWashingBathtub.jpg) 0 0 no-repeat;
      background-size: 100% auto;
    }
  }  
}

</style>
